// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "756aef3f1d518ce1bc06ecb195986880" + ".js";
};